import { defineStore } from 'pinia';
import { Marketplace } from '../entities/marketplace';

export const documentationUrl =
	'https://documenter.getpostman.com/view/21819431/2sB3dSQUKr';

export const useCreateMarketplaceDialogStore = defineStore('createMarketplaceDialog', {
	state: () => ({
		isOpen: false,
		isCustomDialogOpen: false,
		isCustomSuccessDialogOpen: false,
		loading: false,
		marketplaces: [],
	}),

	actions: {
		async fetchUnlinkedMarketplaces() {
			this.loading = true;
			try {
				const data = await Marketplace.getUnlinkedMarketplaces();
				this.marketplaces = data;
			} finally {
				this.loading = false;
			}
		},
		async createMarketplace(marketplaceId) {
			return await Marketplace.createMarketplace({
				marketplace_id: marketplaceId,
			});
		},
		async createCustomMarketplace(data) {
			return await Marketplace.createCustomMarketplace(data);
		},
		openDialog() {
			this.isOpen = true;
			this.fetchUnlinkedMarketplaces();
		},
		openCustomDialog() {
			this.isCustomDialogOpen = true;
		},
		openCustomSuccessDialog() {
			this.isCustomSuccessDialogOpen = true;
		},
		resetData() {
			this.isOpen = false;
			this.isCustomDialogOpen = false;
			this.isCustomSuccessDialogOpen = false;
			this.loading = false;
			this.marketplaces = [];
		},
	},
});
